/* ============================================================
   Kavera - front-end interactions
   Gallery, Tabs, FAQ, synced bundles, sticky add-to-cart,
   Subscribe & Save box (Loop selling plans), gifts placement,
   live dispatch countdown, dynamic savings labels.
   ============================================================ */
(function () {
  'use strict';
  if (window.__kaveraLoaded) return;
  window.__kaveraLoaded = true;

  var KV_SELLING_PLAN = '692934508892';
  var KV_SUB_FACTOR = 0.8;
  var KV_TIERS = {
    '58378076094812': { one: '58683335573852', sub: '58684061319516', plan: '692934476124' },
    '58378081632604': { one: '58683334820188', sub: '58684059943260', plan: '692934312284' },
    '58378081665372': { one: '58683444429148', sub: '58683444429148', plan: '692934508892' }
  };
  var KV_BUNDLE_HEADING = '🎒 Back To School 📚';
  var KV_SUB_NOTE = 'Shipped automatically. No commitment. Cancel anytime.';
  var kvSubscribe = true;

  function kvNum(t) {
    var m = String(t).match(/([\d,]+(?:\.\d{1,2})?)/);
    return m ? parseFloat(m[1].replace(/,/g, '')) : NaN;
  }
  function kvSym(t) {
    var m = String(t).match(/[£$€]/);
    return m ? m[0] : '$';
  }
  function kvMoney(text, factor) {
    return String(text).replace(/([£$€]\s?)([\d,]+(?:\.\d{1,2})?)/g, function (m, sym, num) {
      var v = parseFloat(num.replace(/,/g, ''));
      if (isNaN(v)) return m;
      return sym + (v * factor).toFixed(2);
    });
  }

  function kvSelectedCard() {
    var group = document.querySelector('[data-kv-bundles]');
    if (!group) return null;
    var sel = group.getAttribute('data-selected') || group.getAttribute('data-default') || '0';
    return group.querySelector('[data-kv-bundle][data-index="' + sel + '"]');
  }

  function kvCache(card) {
    if (card.getAttribute('data-kv-cached')) return;
    var p = card.querySelector('.kv-bundle__price');
    var c = card.querySelector('.kv-bundle__compare');
    var s = card.querySelector('.kv-bundle__sub');
    var v = card.querySelector('.kv-bundle__save');
    if (p) card.setAttribute('data-kv-p', p.textContent.trim());
    if (c) card.setAttribute('data-kv-c', c.textContent.trim());
    if (s) card.setAttribute('data-kv-s', s.textContent.trim());
    if (v) card.setAttribute('data-kv-v', v.textContent.trim());
    card.setAttribute('data-kv-cached', '1');
  }

  function kvPaintCard(card) {
    kvCache(card);
    var p = card.querySelector('.kv-bundle__price');
    var c = card.querySelector('.kv-bundle__compare');
    var s = card.querySelector('.kv-bundle__sub');
    var v = card.querySelector('.kv-bundle__save');
    var op = card.getAttribute('data-kv-p') || '';
    var oc = card.getAttribute('data-kv-c') || '';
    var os = card.getAttribute('data-kv-s') || '';
    var ov = card.getAttribute('data-kv-v') || '';

    var shown = kvSubscribe ? kvMoney(op, KV_SUB_FACTOR) : op;
    if (p) p.textContent = shown;
    if (c) c.textContent = oc;
    if (s) s.textContent = kvSubscribe ? kvMoney(os, KV_SUB_FACTOR) : os;

    if (v) {
      var was = kvNum(oc);
      var now = kvNum(shown);
      if (!isNaN(was) && !isNaN(now) && was > now) {
        v.textContent = 'Save ' + kvSym(oc) + (was - now).toFixed(2);
      } else {
        v.textContent = ov;
      }
    }
  }

  function kvPaintSubBoxes() {
    document.querySelectorAll('[data-kv-subbox]').forEach(function (box) {
      var mark = box.querySelector('[data-kv-subcheck]');
      box.style.background = '#ffffff';
      if (kvSubscribe) {
        box.style.borderColor = '#4a86d1';
        if (mark) { mark.style.borderColor = '#4a86d1'; mark.style.color = '#4a86d1'; }
      } else {
        box.style.borderColor = '#c9d4e2';
        if (mark) { mark.style.borderColor = '#c9d4e2'; mark.style.color = 'transparent'; }
      }
    });
  }

  function kvPaintAll() {
    document.querySelectorAll('[data-kv-bundle]').forEach(kvPaintCard);
    kvPaintSubBoxes();
    updateSticky();
  }

  /* ---- Live dispatch countdown ---- */
  function kvStartCountdown() {
    var els = document.querySelectorAll('[data-kv-dispatch]');
    if (!els.length) return;
    var mins = 0;
    els.forEach(function (el) {
      var raw = el.getAttribute('data-kv-raw');
      if (raw === null) { raw = (el.textContent || '').trim(); el.setAttribute('data-kv-raw', raw); }
      var m = raw.match(/(\d+)\s*minutes?/i);
      if (m && !mins) mins = parseInt(m[1], 10);
    });
    if (!mins) return;
    var total = mins * 60;
    function tick() {
      var mm = Math.floor(total / 60);
      var ss = total % 60;
      var stamp = mm + ':' + (ss < 10 ? '0' : '') + ss;
      els.forEach(function (el) {
        var raw = el.getAttribute('data-kv-raw') || '';
        el.textContent = raw.replace(/(\d+)\s*minutes?/i, stamp);
      });
      if (total > 0) total--;
    }
    tick();
    setInterval(tick, 1000);
  }

  function kvBuildHeading(group) {
    if (!KV_BUNDLE_HEADING) return;
    if (group.querySelector('[data-kv-bundleheading]')) return;
    var cards = group.querySelectorAll('[data-kv-bundle]');
    if (!cards.length) return;
    var h = document.createElement('div');
    h.setAttribute('data-kv-bundleheading', '');
    h.style.cssText = 'display:flex; align-items:center; gap:12px; margin:0 0 16px;';
    h.innerHTML =
      '<span style="flex:1; height:1px; background:#e6ebf2;"></span>' +
      '<span style="font-size:16.5px; font-weight:800; color:#c2410c; letter-spacing:-0.01em; white-space:nowrap;">' + KV_BUNDLE_HEADING + '</span>' +
      '<span style="flex:1; height:1px; background:#e6ebf2;"></span>';
    cards[0].parentNode.insertBefore(h, cards[0]);
  }

  function kvBuildSubBox(group) {
    if (group.querySelector('[data-kv-subbox]')) return;
    var cards = group.querySelectorAll('[data-kv-bundle]');
    if (!cards.length) return;
    var last = cards[cards.length - 1];
    var box = document.createElement('div');
    box.setAttribute('data-kv-subbox', '');
    box.setAttribute('role', 'checkbox');
    box.setAttribute('tabindex', '0');
    box.style.cssText = 'display:flex; gap:13px; align-items:flex-start; border:2px dashed #4a86d1; background:#ffffff; border-radius:14px; padding:15px 16px; margin:4px 0 6px; cursor:pointer; transition:border-color .18s ease;';
    box.innerHTML =
      '<span data-kv-subcheck style="flex:none; width:23px; height:23px; border:2px solid #4a86d1; background:#ffffff; color:#4a86d1; border-radius:6px; display:flex; align-items:center; justify-content:center; font-size:14px; font-weight:800; line-height:1; margin-top:1px;">✓</span>' +
      '<span style="flex:1;">' +
        '<span style="display:block; font-size:15.5px; font-weight:800; color:#141f39; letter-spacing:-0.01em;">Save 20% with automatic refills</span>' +
        '<span data-kv-subnote style="display:block; font-size:13.5px; color:#5f7086; margin-top:3px; line-height:1.45;">' + KV_SUB_NOTE + '</span>' +
      '</span>';
    last.parentNode.insertBefore(box, last.nextSibling);
  }

  function kvMoveGifts() {
    var gifts = document.querySelector('.kv-section-gifts');
    var atc = document.querySelector('.kv-atc');
    if (!gifts || !atc || !atc.parentNode) return;
    atc.parentNode.insertBefore(gifts, atc);
  }

  /* ---- Gallery ---- */
  function paintGallery(gallery) {
    var index = parseInt(gallery.getAttribute('data-index') || '0', 10);
    var thumbs = gallery.querySelectorAll('[data-kv-thumb]');
    var count = thumbs.length;
    if (!count) return;
    if (index < 0) index = count - 1;
    if (index >= count) index = 0;
    gallery.setAttribute('data-index', String(index));
    var active = thumbs[index];
    var main = gallery.querySelector('[data-kv-gallery-main]');
    if (main && active) {
      main.setAttribute('src', active.getAttribute('data-src') || '');
      main.setAttribute('alt', active.getAttribute('data-alt') || 'Product photo');
    }
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    var badge = gallery.querySelector('[data-kv-gallery-badge]');
    if (badge) badge.style.display = index === 0 ? '' : 'none';
  }
  function stepGallery(gallery, dir) {
    var index = parseInt(gallery.getAttribute('data-index') || '0', 10);
    gallery.setAttribute('data-index', String(index + dir));
    paintGallery(gallery);
  }

  /* ---- Tabs ---- */
  function selectTab(tabs, index) {
    tabs.querySelectorAll('[data-kv-tab]').forEach(function (btn, i) { btn.classList.toggle('is-active', i === index); });
    tabs.querySelectorAll('[data-kv-panel]').forEach(function (panel, i) { panel.classList.toggle('is-active', i === index); });
    var panelWrap = tabs.querySelector('[data-kv-panels]');
    if (panelWrap) { panelWrap.style.borderRadius = index === 0 ? '0 14px 14px 14px' : '14px'; }
  }

  /* ---- Bundles ---- */
  function selectBundle(index) {
    document.querySelectorAll('[data-kv-bundle]').forEach(function (card) {
      var i = parseInt(card.getAttribute('data-index') || '0', 10);
      card.classList.toggle('is-selected', i === index);
    });
    document.querySelectorAll('[data-kv-bundles]').forEach(function (group) {
      group.setAttribute('data-selected', String(index));
    });
    updateSticky();
  }

  /* ---- Add to cart ---- */
  function kvCartItem() {
    var card = kvSelectedCard();
    if (!card) return null;
    var raw = (card.getAttribute('data-variant-id') || '').trim();
    var tier = KV_TIERS[raw];
    if (!tier) return { id: parseInt(raw, 10), quantity: 1 };
    if (kvSubscribe) {
      return { id: parseInt(tier.sub, 10), quantity: 1, selling_plan: tier.plan || KV_SELLING_PLAN };
    }
    return { id: parseInt(tier.one, 10), quantity: 1 };
  }
  function addVariant(item, button) {
    var label = button.textContent;
    button.classList.add('is-busy');
    button.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
      .catch(function () { button.classList.remove('is-busy'); button.textContent = label; window.alert('Sorry, something went wrong adding this to your cart. Please try again.'); });
  }
  function addSelectedBundle(button) {
    if (button.classList.contains('is-busy')) return;
    var item = kvCartItem();
    if (!item || !item.id) { window.location.href = '/cart'; return; }
    addVariant(item, button);
  }

  /* ---- Sticky bar ---- */
  function updateSticky() {
    var bar = document.querySelector('[data-kv-sticky]');
    if (!bar) return;
    var groups = document.querySelectorAll('[data-kv-bundles]');
    if (!groups.length) return;
    var first = groups[0];
    var sel = first.getAttribute('data-selected') || '0';
    var card = first.querySelector('[data-kv-bundle][data-index="' + sel + '"]');
    if (card) {
      var titleEl = card.querySelector('.kv-bundle__title');
      var priceEl = card.querySelector('.kv-bundle__price');
      var st = bar.querySelector('[data-kv-sticky-title]');
      var sp = bar.querySelector('[data-kv-sticky-price]');
      if (st && titleEl) st.textContent = (titleEl.textContent || '').trim();
      if (sp && priceEl) sp.textContent = (priceEl.textContent || '').trim();
    }
    var anyVisible = false;
    groups.forEach(function (g) {
      var r = g.getBoundingClientRect();
      if (r.top < (window.innerHeight - 60) && r.bottom > 60) anyVisible = true;
    });
    var scrolledPast = first.getBoundingClientRect().top < 0;
    if (!anyVisible && scrolledPast) bar.classList.add('is-visible');
    else bar.classList.remove('is-visible');
  }

  /* ---- Wire up ---- */
  document.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-kv-subbox]'))) {
      kvSubscribe = !kvSubscribe;
      kvPaintAll();
      return;
    }
    if ((el = e.target.closest('[data-kv-gallery-prev]'))) { stepGallery(el.closest('[data-kv-gallery]'), -1); return; }
    if ((el = e.target.closest('[data-kv-gallery-next]'))) { stepGallery(el.closest('[data-kv-gallery]'), 1); return; }
    if ((el = e.target.closest('[data-kv-thumb]'))) {
      var gallery = el.closest('[data-kv-gallery]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-kv-thumb]'));
      gallery.setAttribute('data-index', String(thumbs.indexOf(el)));
      paintGallery(gallery);
      return;
    }
    if ((el = e.target.closest('[data-kv-tab]'))) {
      var tabs = el.closest('[data-kv-tabs]');
      var btns = Array.prototype.slice.call(tabs.querySelectorAll('[data-kv-tab]'));
      selectTab(tabs, btns.indexOf(el));
      return;
    }
    if ((el = e.target.closest('[data-kv-faq-toggle]'))) { el.closest('[data-kv-faq-item]').classList.toggle('is-open'); return; }
    if ((el = e.target.closest('[data-kv-sticky-btn]'))) { addSelectedBundle(el); return; }
    if ((el = e.target.closest('[data-kv-bundle]'))) { selectBundle(parseInt(el.getAttribute('data-index') || '0', 10)); return; }
    if ((el = e.target.closest('.kv-atc'))) { addSelectedBundle(el); return; }
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === ' ' || e.key === 'Enter') && e.target.closest && e.target.closest('[data-kv-subbox]')) {
      e.preventDefault();
      kvSubscribe = !kvSubscribe;
      kvPaintAll();
    }
  });

  /* ---- Init ---- */
  function init() {
    document.querySelectorAll('[data-kv-gallery]').forEach(paintGallery);
    document.querySelectorAll('[data-kv-tabs]').forEach(function (tabs) {
      var def = parseInt(tabs.getAttribute('data-default') || '0', 10);
      selectTab(tabs, def);
    });
    document.querySelectorAll('[data-kv-bundles]').forEach(function (g) {
      kvBuildHeading(g);
      kvBuildSubBox(g);
    });
    kvMoveGifts();
    kvStartCountdown();
    var firstBundles = document.querySelector('[data-kv-bundles]');
    if (firstBundles) selectBundle(parseInt(firstBundles.getAttribute('data-default') || '0', 10));
    kvPaintAll();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
